export const DRAWER_WIDTH = 256;
export const COLLAPSED_DRAWER_WIDTH = 64;
